var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import queryString from 'query-string';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
const mapStateToProps = createStructuredSelector({
    location: (state) => state.location,
});
class OutboundLink extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            href: null,
        };
        this._handleMouseDown = () => {
            const query = pickBy({
                url: this.props.href,
                dp: `${location.pathname}${location.search}`,
                ec: this.props.category,
                ea: this.props.action,
                el: this.props.label,
                ev: this.props.value,
                params: JSON.stringify(this.props.params),
            }, identity);
            this.setState({
                href: `/track?${queryString.stringify(query)}`,
            });
        };
        this._handleMouseUp = () => {
            setTimeout(() => {
                if (!this._mounted)
                    return;
                this.setState({
                    href: null,
                });
            }, 1);
        };
    }
    componentDidMount() {
        this._mounted = true;
    }
    componentWillUnmount() {
        this._mounted = false;
    }
    render() {
        // eslint-disable-next-line
        const _a = this.props, { children, location, dispatch, href, category, action, label, value, params } = _a, props = __rest(_a, ["children", "location", "dispatch", "href", "category", "action", "label", "value", "params"]);
        return (_jsx("a", Object.assign({}, props, { href: this.state.href || href, onMouseDown: this._handleMouseDown, onMouseUp: this._handleMouseUp, children: children })));
    }
}
export default connect(mapStateToProps)(OutboundLink);
